// extracted by mini-css-extract-plugin
module.exports = {"odometer":"Odometer_odometer__UQlC0"};